export type VoicePhase='idle'|'connecting'|'ready'|'listening'|'thinking'|'speaking'|'muted'|'error';
export const voiceLabels:Record<VoicePhase,string>={idle:'Parliamone a voce',connecting:'Mi sto collegando…',ready:'Ti ascolto',listening:'Sto ascoltando…',thinking:'Ci sto pensando…',speaking:'Sto parlando',muted:'Microfono spento',error:'Voce non disponibile'};
export function voiceEvent(current:VoicePhase,type:string):VoicePhase {
 if(current==='idle'||current==='error')return current;
 if(type==='error')return 'error';
 if(current==='muted')return current;
 if(type==='input_audio_buffer.speech_started')return 'listening';
 if(type==='input_audio_buffer.speech_stopped'||type==='response.created')return 'thinking';
 if(type==='output_audio_buffer.started')return 'speaking';
 if(type==='output_audio_buffer.stopped'||type==='output_audio_buffer.cleared')return 'ready';
 if(type==='session.created')return 'ready';
 // response.done means generation ended; playback can still be draining.
 return current;
}
